import { Alert, CircularProgress, Stack } from "@mui/material";
import { useParams } from "react-router-dom";

import { useCase } from "../api/useCase";
import { MobileEditCaseForm } from "./MobileEditCaseForm";

export function MobileEditCaseContainer() {
  const { caseId } = useParams<{ caseId: string }>();
  const { data: caseItem, isLoading, isError } = useCase(caseId);

  if (isLoading) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ minHeight: "40vh" }}>
        <CircularProgress />
      </Stack>
    );
  }

  if (isError || !caseItem) {
    return (
      <Alert severity="error" sx={{ m: 3 }}>
        Error loading case.
      </Alert>
    );
  }

  return <MobileEditCaseForm case={caseItem} />;
}
